export default __webpack_public_path__ + "static/2022_2023_WVS INDIA CONSOLIDATED ACCOUNTS-24a382556588c476a302b99f019a4df7.pdf";